'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import logo from 'bender-url!../../img/hubspot-tools-logo.png';
import text from 'I18n/utils/unescapedText';
import { useTheme } from 'styled-components';

var Logo = function Logo(_ref) {
  var onClick = _ref.onClick;
  var classes = Boolean(onClick) ? "clickable" : "";
  var theme = useTheme();
  return /*#__PURE__*/_jsx("div", {
    className: "logo",
    children: /*#__PURE__*/_jsx("img", {
      width: "151px",
      alt: text('altText.logo'),
      className: "" + classes,
      src: theme.logo && theme.logo.url || logo,
      onClick: onClick
    })
  });
};

Logo.defaultProps = {
  isClickable: false
};
export default Logo;